'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoDiffRemoved = function GoDiffRemoved(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 2.5h-30c-1.2 0-2.5 1.3-2.5 2.5v30c0 1.3 1.3 2.5 2.5 2.5h30c1.3 0 2.5-1.2 2.5-2.5v-30c0-1.2-1.2-2.5-2.5-2.5z m-2.5 28.8c0 0.6-0.7 1.2-1.2 1.2h-22.5c-0.8 0-1.3-0.5-1.3-1.2v-22.5c0-0.7 0.6-1.3 1.3-1.3h22.5c0.5 0 1.2 0.6 1.2 1.3v22.5z m-20-8.8h15v-5h-15v5z' })
        )
    );
};

exports.default = GoDiffRemoved;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/diff-removed.js
// module id = 2150
// module chunks = 168707334958949